// frontend/src/components/AGTFit/service/agtfitProService.js
import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Configuración base para las peticiones al API según el entorno
const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5003'
  : (process.env.REACT_APP_API_FIT_URL);

// Prefijo de API según entorno
const API_PREFIX = process.env.NODE_ENV === 'development' ? '/api' : '';

// URL completa
const API_URL = `${API_BASE}${API_PREFIX}`;

// Crear cliente axios
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
  timeout: 60000 // 60 segundos (las consultas a Claude pueden tardar)
});

// Interceptor para añadir token de autenticación
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (user) {
        const token = await user.getIdToken();
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error al obtener token de Firebase:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const agtfitProService = {
  // Verificar si el usuario es PRO
  checkProStatus: async () => {
    try {
      // Ruta actualizada para incluir /pro
      const response = await apiClient.get('/pro/status');
      return response.data;
    } catch (error) {
      console.error('Error checking AGTFit PRO status:', error);
      return { isPro: false };
    }
  },

  // Crear sesión de pago con Stripe
  createCheckoutSession: async () => {
    try {
      // Ruta actualizada para incluir /pro
      const response = await apiClient.post('/pro/create-checkout-session');
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  // Crear portal de cliente para gestionar suscripción
  createCustomerPortal: async () => {
    try {
      // Ruta actualizada para incluir /pro
      const response = await apiClient.post('/pro/create-customer-portal');
      return response.data;
    } catch (error) {
      console.error('Error creating customer portal:', error);
      throw error;
    }
  }
};

export default agtfitProService;